/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { Language } from '../../../ts/skill';

export const MULTILINGUAL_CONVERSATIONAL_SEARCH_LANGUAGES = Object.freeze([
  Language.English,
  Language.French,
  Language.German,
  Language.PortugueseBrazilian,
  Language.Spanish
]);
